$(document).ready(function () {
    // Initialize event listener for the "Load More" button
    $('.js-load-more').on('click', function () {
        var $this = $(this);
        var totalPages = parseInt($('[data-all-pages]').val());
        var currentPage = parseInt($('[data-this-page]').val());
        var datacollurl = window.location.href;

        console.log("datacollurl", datacollurl);
        var nextUrl = $('[data-next-link]').val();
        var current_page_new = currentPage + 1;
        var next_coll = currentPage + 2;

        console.log("current", current_page_new);
        console.log("next page", next_coll);
        console.log("all pages", totalPages);

        $.ajax({
            url: nextUrl,
            type: 'GET',
            dataType: 'html',
            beforeSend: function () {
                $this.find('[loader]').find(".load-more_spinner").css('display', "block");
            },
            success: function (responseHTML) {
                $('[data-next-link]').val(datacollurl + "?page=" + next_coll);
                $('[data-this-page]').val(current_page_new);
                var ChildHtmlli = $(responseHTML).find('#product-grid').html();
                console.log(ChildHtmlli, 'html');
                $('#product-grid').append(ChildHtmlli);
            },
            complete: function () {
                if (current_page_new < totalPages) {
                    $this.attr('disabled', false);
                    $this.find('[load-more-text]').removeClass('hide');
                } else {
                    $this.attr('disabled', true);
                    $this.find('[load-more-text]').text('No More Products').removeClass('hide');
                }
                $this.find('[loader]').find(".load-more_spinner").css('display', "none");
                var total_li_count = $('#product-grid li').length;
                $('span.total-products').text(total_li_count);
            }
        });
    });

    // Handle form submission
    $('#filter-form').on('submit', function (event) {
        event.preventDefault(); // Prevent the default form submission

        // Get form parameters
        var params = $(this).serialize(); // Serialize form data to query string
        var newUrl = window.location.pathname + "?" + params; // Create new URL with parameters

        // Update the browser URL without reloading
        window.history.pushState({ path: newUrl }, '', newUrl);

        // Load products with new parameters
        loadProductsWithFilters(params, newUrl);
    });

    // Function to load products with the specified filters
    function loadProductsWithFilters(params, newUrl) {
        $.ajax({
            url: newUrl + params, // Update with correct URL
            type: 'GET',
            dataType: 'html',
            beforeSend: function () {
                $('#product-grid').html('<p>Loading products...</p>'); // Optional loading indicator
            },
            success: function (responseHTML) {
                var newProducts = $(responseHTML).find('#product-grid').html();
                $('#product-grid').html(newProducts); // Replace with new products

                // Optionally reset the pagination data here
                $('[data-next-link]').val(newUrl + "&page=2"); // Set next link based on the new URL
                $('[data-this-page]').val(1); // Reset current page
                $('[data-all-pages]').val(2); // Assuming there's only 1 page after the filter
            }
        });
    }
});
